import { useEffect } from 'react';
import { useContent } from '../redux/reducer/content';
import { useUser } from '../redux/reducer/user';
import useCustomBridge from './useCustomBridge';
import CustomBridge from '../controllers/bridge/CustomBridge';
import { isArray, isFunction } from 'lodash';
import { COMPLETED_PROFILE } from '../constants/task';
import { useApplicationCallbacks } from '../providers/application-callbacks';

const someQuestsSettings = [
  {
    triggerCondition({ Bridge }) {
      Bridge.instance.send({ name: 'CHECK_USER_DATA_FILLED', type: 0 });
    },
    isSameQuest({ quest }) {
      return quest.uid === COMPLETED_PROFILE;
    },
    getCondition({ quest, completedUserData }) {
      return Boolean(
        Object.values(completedUserData).length && Object.values(completedUserData).every(Boolean) && !quest.isComplete,
      );
    },
    onCompleteConditionCallback({ callbacks, quest }) {
      callbacks.completeQuest({ id: quest.id });
    },
  },
];

export const useCheckOnCompleteSomeQuests = () => {
  const { quests } = useContent();
  const { completedUserData } = useUser();

  const callbacks = useApplicationCallbacks();

  useCustomBridge(callbacks);

  useEffect(() => {
    const pumpedProps = { Bridge: CustomBridge };

    someQuestsSettings.forEach(({ triggerCondition }) => {
      isFunction(triggerCondition) && triggerCondition(pumpedProps);
    });
  }, []);

  useEffect(() => {
    if (!quests) return;

    someQuestsSettings.forEach(({ isSameQuest, getCondition, onCompleteConditionCallback }) => {
      const allQuests = quests?.reduce((acc, quest) => {
        const sameQuests = [];

        const isSame = isSameQuest({ quest });
        if (isSame) sameQuests.push(quest);

        const { subQuests } = quest;
        if (isArray(subQuests))
          subQuests.forEach((quest) => {
            if (isSameQuest({ quest })) sameQuests.push(quest);
          });

        return [...acc, ...sameQuests];
      }, []);

      if (!allQuests?.length) return;

      allQuests.forEach((quest) => {
        const pumpedProps = { quest: quest, callbacks, completedUserData };
        if (getCondition(pumpedProps)) onCompleteConditionCallback(pumpedProps);
      });
    });
  }, [quests, completedUserData]);
};
